'use strict';
import { Buildings, GSAPAnimationMixer, projectMode, settingsData, threeJsVariables } from '../../settings';
import {
    getWorldData
} from './orbitControls';
import gsap from "gsap";
import {enableSwitcherBtns} from "../../functions";
import { Box3, Vector3 } from 'three';
import { updateShadowMap } from '../threejs/lights';

export async function bombButtonInitActionHandler() {
    enableSwitcherBtns(true);
    if (settingsData.buildingDestroyed) {
        await projectMode.FloorPlan.exitFromMode();
    } else {
        await projectMode.FloorPlan.enter();
    }
}

// export const destroyCameraAnimation = (targetPosition, upper, flat) => {
//     const apt = flat ? flat : settingsData.lastClickedFlat;
//     const {cameraVector, orbitControlsVector, flatVector} = getWorldData(apt);
//     const {minAngle} = getPolarAngleFromViewMode(ViewMode.FloorPlan);
//     const {minDistance} = getOrbitControlsDistanceAndPan(ViewMode.FloorPlan);
//     const distanceCorrection = config.threejs.orbitControls.floorplan.minDistanceCorrection;
//
//     const position = targetPosition ? targetPosition : flatVector;
//
//     const aptTarget = new Vector3().copy(orbitControlsVector).setY(position.y);
//     const aptPosition = new Vector3().subVectors(position,aptTarget).normalize().setY(position.y).setLength(minDistance * distanceCorrection).add(aptTarget);
//
//     animateCamera(
//         cameraVector,
//         aptPosition,
//         orbitControlsVector,
//         aptTarget,
//         undefined,
//         minDistance,
//         minAngle,
//         0,
//         1000,
//         TWEEN.Easing.Linear.None,
//         () => {
//                 setOrbitControls(ViewMode.FloorPlan);
//                 setPolarAngle(ViewMode.FloorPlan);
//                 setMinAndMaxControlsDistance(ViewMode.FloorPlan);
//                 threeJsVariables.orbitControls.saveState();
//         }
//     );
//
// }

const box = new Box3();
const size = new Vector3();

export const floorMoveAnimation = (currentFloor, action, chosenFloor,state) => {
    const mixer = GSAPAnimationMixer.getMixer('floorPlan');
    const activeBuilding = Buildings.getActiveBuilding();
    const { floors,floorSelectionGroup } = activeBuilding.getFloors(currentFloor,chosenFloor);
    let fallingDownSelections = [];

    const appear = action === 'appear';
    if (!appear)
        fallingDownSelections = activeBuilding.getFloorSelections(currentFloor,false);

    const duration = GSAPAnimationMixer.duration;
    const animationDiff = duration / floorSelectionGroup.length;
    const slicerTimes = [];
    for (let i = 0; i < floorSelectionGroup.length; i ++) {
        const instanceMesh = floors[i];
        const selectionsFloorGroup = floorSelectionGroup[i];
        const animationDuration = animationDiff * i;
        /*  Animate floors */

        if (!threeJsVariables.slicer.active) {
            if ((instanceMesh && !instanceMesh.hiddenFloor || appear) && !projectMode.LiteMode.isActive() || (projectMode.LiteMode.isActive() && (projectMode.LiteMode.modeIs('regular') || projectMode.LiteMode.modeIs('rotate')))) {

            // const floorPromise = new Promise((resolve => {
                const animation = gsap.to(instanceMesh.position, {
                        x: instanceMesh.position.x,
                        y: action === "destroy" ? instanceMesh.position.y + 400 : instanceMesh.basePosition.y,
                        z: instanceMesh.position.z,
                        duration: duration - animationDuration,
                        delay: appear ? animationDuration : 0,
                        ease: GSAPAnimationMixer.ease,
                        onUpdate: () => {
                            settingsData.bombBlock = true;
                            config.threejs.orbitControls.enabled = false;
                            instanceMesh.matrix.setPosition(instanceMesh.position.x, instanceMesh.position.y, instanceMesh.position.z);
                            instanceMesh.mesh.setMatrixAt(instanceMesh.count, instanceMesh.matrix);
                            instanceMesh.mesh.instanceMatrix.needsUpdate = true;
                            instanceMesh.mesh.updateMatrix();
                        },
                        onComplete: () => {
                            instanceMesh.hiddenFloor = action === "destroy";
                            settingsData.bombBlock = false;
                            config.threejs.orbitControls.enabled = true;
                        }
                    }
                );

                mixer.addAnimation(animation);
            }
        }

        /**
         Animate selections
         */
        if (!selectionsFloorGroup.userData.hiddenFloor || action === "appear") {
            
            slicerTimes.push(animationDuration);

            // const selectionsPromise = new Promise(resolve => {
            const animation = gsap.to(selectionsFloorGroup.position, {
                    x: selectionsFloorGroup.position.x,
                    y: action === "destroy" ? selectionsFloorGroup.position.y + 400 : selectionsFloorGroup.userData.basePosition.y,
                    z: selectionsFloorGroup.position.z,
                    duration: duration - animationDuration,
                    delay: appear ? animationDuration : 0,
                    ease: GSAPAnimationMixer.ease,
                    onUpdate:() => {
                        updateShadowMap();
                    },
                    onComplete: () => {
                        selectionsFloorGroup.userData.hiddenFloor = action === "destroy";
                        // resolve(true);
                    }
                },
                // appear
                // ? i === 0
                //     ? ""
                //     : `-=${animationDuration}`
                // : null
            );

            mixer.addAnimation(animation);
            // });

            // animations.push(selectionsPromise);

        }
    }

    const slicerFloor = typeof chosenFloor === 'number' ? chosenFloor : currentFloor;
    slicerFloorMove(state,action,slicerFloor,Math.max(...slicerTimes));

    /* Animate current floor selections */
    if (fallingDownSelections.length) {
        const { flatVector } = getWorldData(fallingDownSelections[0]);
        // const startFallingY = flatVector.y + 100;
        const startFallingY = fallingDownSelections[0].userData.base_position.y + 10;

        // const fallingDownAnimations = fallingDownFloorSelections(fallingDownSelections,startFallingY);
        fallingDownFloorSelections(fallingDownSelections,startFallingY);
        // animations.push(...fallingDownAnimations);
    }


    // return Promise.all(animations);





    // const tl = appear ? gsap.timeline() : gsap;
    // const movingSelections = [];
    // let currentFloorSelections = [];
    // const zero = config.resources.bundle.selectionBoxes.floorPlugName;
    // const regex = new RegExp(zero);
    // let fallingDownSelectBoxesAnimations = [];
    //
    //
    // activeBuilding.selectionsGroup.traverse(child => {
    //     if (!child.parent.name.match(activeBuilding.name)) return;
    //     const floor = child.name?.match(/F/g);
    //     if (floor) {
    //         const floorNum = child.name.split("_")[1];
    //         if (parseInt(floorNum) === parseInt(currentFloor)) {
    //             child.traverse((selection) => {
    //                 selection.type === "Mesh" && !selection.name.match(regex) && currentFloorSelections.push(selection);
    //             });
    //         }
    //         if (chosenFloor) {
    //             floorNum > currentFloor && floorNum <= chosenFloor && movingSelections.push(child);
    //         } else {
    //             floorNum > currentFloor && movingSelections.push(child);
    //         }
    //     }
    // });
    //
    // const duration = 1.3;
    // const animationDiff = duration / movingSelections.length;
    // for (let i = 0; i < movingSelections.length; i++) {
    //
    //     const instanceMesh = movingFloors[i];
    //     const selectionsFloorGroup = movingSelections[i];
    //     const animationDuration = duration - animationDiff * i;
    //
    //     /**
    //      * Animate floors
    //      */
    //
    //     if ((instanceMesh && !instanceMesh.hiddenFloor || appear) && !projectMode.LiteMode.isActive() || (projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('regular'))) {
    //
    //         const floorPromise = new Promise((resolve => {
    //             tl.to(instanceMesh.position, {
    //                     x: instanceMesh.position.x,
    //                     y: action === "destroy" ? instanceMesh.position.y + 400 : instanceMesh.basePosition.y,
    //                     z: instanceMesh.position.z,
    //                     duration: appear ? animationDuration : 1.3,
    //                     ease: "power4.inOut",
    //                     onUpdate: () => {
    //                         settingsData.bombBlock = true;
    //                         config.threejs.orbitControls.enabled = false;
    //                         instanceMesh.matrix.setPosition(instanceMesh.position.x, instanceMesh.position.y, instanceMesh.position.z);
    //                         instanceMesh.mesh.setMatrixAt(instanceMesh.count, instanceMesh.matrix);
    //                         instanceMesh.mesh.instanceMatrix.needsUpdate = true;
    //                         instanceMesh.mesh.updateMatrix();
    //                     },
    //                     onComplete: () => {
    //                         instanceMesh.hiddenFloor = action === "destroy";
    //                         settingsData.bombBlock = false;
    //                         config.threejs.orbitControls.enabled = true;
    //                         resolve(true);
    //                     }
    //
    //                 }, appear
    //                 ? i === 0
    //                     ? ""
    //                     : `-=${animationDuration}`
    //                 : null
    //             );
    //
    //         }));
    //
    //         animations.push(floorPromise);
    //
    //     }
    //
    //     /**
    //      * Animate selections
    //      */
    //     if (!selectionsFloorGroup.userData.hiddenFloor || action === "appear") {
    //
    //         const selectionsPromise = new Promise(resolve => {
    //             tl.to(selectionsFloorGroup.position, {
    //                     x: selectionsFloorGroup.position.x,
    //                     y: action === "destroy" ? selectionsFloorGroup.position.y + 400 : selectionsFloorGroup.userData.basePosition.y,
    //                     z: selectionsFloorGroup.position.z,
    //                     duration: appear ? animationDuration : 1.3,
    //                     ease: "power4.inOut",
    //                     onStart: () => {
    //                         /**
    //                          * Animate current floor selections
    //                          */
    //                         // !appear && fallingDownFloorSelections(currentFloorSelections, selectionsFloorGroup.position.y);
    //                         if (!appear){
    //                             fallingDownSelectBoxesAnimations = fallingDownFloorSelections(currentFloorSelections, selectionsFloorGroup.position.y);
    //                         }
    //
    //                     },
    //                     onComplete: () => {
    //                         selectionsFloorGroup.userData.hiddenFloor = action === "destroy";
    //                         resolve(true);
    //                     }
    //                 }, appear
    //                 ? i === 0
    //                     ? ""
    //                     : `-=${animationDuration}`
    //                 : null
    //             );
    //
    //         });
    //
    //         animations.push(selectionsPromise);
    //
    //     }
    // }
    //
    // return Promise.all(animations.concat(fallingDownSelectBoxesAnimations));
};


function slicerFloorMove (state,action,floorNumber,duration) {
    if (threeJsVariables.slicer.active || threeJsVariables.sceneObjectsSlicer.active) {
        if (!isFinite(duration)) {
            duration = GSAPAnimationMixer.duration;
        }
      
        const slicer = threeJsVariables.slicer.active ? threeJsVariables.slicer : threeJsVariables.sceneObjectsSlicer;
        const mixer = GSAPAnimationMixer.getMixer('floorPlan');
        const duration2 = GSAPAnimationMixer.duration;

        if (state === 'exit') {
            const from = {value: slicer.y};

            const animation = gsap.to(from,{
                value: slicer.distance,
                onUpdate: () => {
                    slicer.y = from.value;
                    if (threeJsVariables.slicer.active) {
                        threeJsVariables.sceneObjectsSlicer.y = from.value;
                    }
                },
                ease: GSAPAnimationMixer.ease,
                duration: duration2 - duration,
                delay: duration
            });
            mixer.addAnimation(animation);
        } else {
            const activeBuilding = Buildings.getActiveBuilding();
            const apartments = activeBuilding.getFloorSelections(floorNumber);
            const floor = apartments[0].parent;
            box.setFromObject(floor);
            box.getSize(size);

            const height = floor.userData.baseWorldPosition.y + size.y;
            const from = {
                value: slicer.y
            };

            const animation = gsap.to(from,{
                value: height,
                onUpdate: () => {
                   slicer.y = from.value;
                   if (threeJsVariables.sceneObjectsSlicer.active) {
                       threeJsVariables.sceneObjectsSlicer.y = from.value;
                   }
                },
                ease: GSAPAnimationMixer.ease,
                duration: state === 'enter' ? 0.2 : duration2
            });
            mixer.addAnimation(animation);
        }
    }
}

export const fallingDownFloorSelections = (currentFloorSelections, currentPosition) => {
    // const animations = [];
    const mixer = GSAPAnimationMixer.getMixer('floorPlan');

    const duration = GSAPAnimationMixer.duration;
    const animationDiff = duration / currentFloorSelections.length;

    for (let i = 0; i < currentFloorSelections.length; i++) {
        const animationDelay = animationDiff * i;

        // const fallingDownPromise = new Promise(resolve => {

            const animation = gsap.fromTo(currentFloorSelections[i].position, {
                    x: currentFloorSelections[i].position.x,
                    y: currentPosition,
                    z: currentFloorSelections[i].position.z,
                },
                {
                    x: currentFloorSelections[i].position.x,
                    y: currentFloorSelections[i].userData.base_position.y,
                    z: currentFloorSelections[i].position.z,
                    duration: duration - animationDelay,
                    ease: GSAPAnimationMixer.ease,
                    // onComplete: ()=>{
                    //   resolve();
                    // },
                }
            );

            mixer.addAnimation(animation);

        // });

        // animations.push(fallingDownPromise);
    }

    // return animations;
};
